import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from "../../axios/axiosconf";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import ModalForm from "../general/ModalForm";
import Loading from "../general/Loading";

function ParametrosNotaCredito() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);

    const [consecutivo, setConsecutivo] = useState();
    const [parametrosId, setParametrosId] = useState();

    const [errorlist, setErrorlist] = useState({});
    
    const [parametrosExisten, setParametrosExisten] = useState(false);

    let history = useHistory();

    let userdata = [];
    let clientData = [];


    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });

        axios.get('parametros-nota-credito?uid='+userdata.user_id,config)
            .then(response => {
                console.log(response.data);
                if (response.data) {
                    setParametrosExisten(true);
                    setParametrosId(response.data.id);
                    setConsecutivo(response.data.consecutivo);
                }
            })
            .catch(error => console.log(error.response.data))
        
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            client_id: client.client_id,
            consecutivo: consecutivo
        };
        
        console.log(conf);
        if (parametrosExisten) {
            conf.id = parametrosId;
            axios.put('/parametros-nota-credito', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los parámetros de factura electrónica han sido modificados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        else {
            axios.post('/parametros-nota-credito', conf)
                .then(
                    response => {
                        setLoading(false);
                        localStorage.setItem('toastmsg', 'Los parámetros de factura electrónica han sido creados');
                        history.push('/parametros-sistema');
                    }
                )
                .catch(
                    err => {
                        setErrorlist(err.response.data.errors);
                        setLoading(false);
                    }
                )
        }
        
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/parametros-sistema">Parámetros del Sistema</Link></li>
                                        <li className="breadcrumb-item" key="bc4">Parametrizar Nota Crédito Electrónica</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Parametrizar Nota Crédito Electrónica</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                                <div className="col-md-10">
                                    <form id="role-form" onSubmit={handleSubmit}>
                                        <div className="card">
                                            <div id="infobasica">
                                                <div className="card-body">

                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group">
                                                                <label>Consecutivo</label>
                                                                <input type="text" name="consecutivo" className="form-control" id="consecutivo" value={consecutivo} onChange={(e) => setConsecutivo(e.target.value)} autoFocus />
                                                                <div className="invalid-feedback visible">
                                                                {errorlist.consecutivo}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="submit" className="btn btn-primary">
                                                        Guardar&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default ParametrosNotaCredito;